// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-assets/app-settings-assets.less
// module id = 3170
// module chunks = 0